import React from "react";

// ====== COMING SOON IMAGES ======
import comingSoonDesktop from "../img/coming-soon-desktop.jpg";
import comingSoonMobile from "../img/coming-soon-mobile.png";

/* ====== CÓDIGO ORIGINAL (NO BORRAR) ======

import { useLanguage } from "../context/LanguageContext";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Contact from "../components/Contact";
import heroImage from "../img/HEROHOME.png";
import BannerEditorial from "../components/BannerEditorial";
import BannerFestival from "../components/BannerFestival";

const translations = {
  ES: {
    heroTitle: "La creatividad del territorio",
    heroDescription:
      "Conectamos personas, sabores e ideas con raíces ampurdanesas.",
  },
  CAT: {
    heroTitle: "La creativitat del territori",
    heroDescription:
      "Connectem persones, sabors i idees amb arrels empordaneses",
  },
};

const Home = ({ contactRef }) => {
  const { language } = useLanguage();
  const { heroTitle, heroDescription } = translations[language];

  return (
    <div>
      <Hero
        title={heroTitle}
        description={heroDescription}
        backgroundImage={heroImage}
      />
      <Services />
      <BannerEditorial />
      <BannerFestival />
      <Contact contactRef={contactRef} />
    </div>
  );
};

export default Home;

====== FIN CÓDIGO ORIGINAL ====== */

// ====== COMING SOON TEMPORAL ======
// !!!!!!!!!!!!!!CAMBIAR CSS EN GLOBAL.CSS!!!!!!!!!!!!!!!!!!!
const Home = () => {
  return (
    <div className="coming-soon">
      <picture>
        {/* MÓVIL */}
        <source srcSet={comingSoonMobile} media="(max-width: 768px)" />

        {/* DESKTOP */}
        <img
          src={comingSoonDesktop}
          alt="Grup Empordà Creatiu · Estem treballant en la nostra pròxima web"
          className="coming-soon-image"
        />
      </picture>
    </div>
  );
};

export default Home;
